
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { Invitation, InvitationStatusEnum } from "@models/invitation";
import { TableModule } from "primeng/table";
import { InvitationStatusEnumPipe } from "../../../../shared/pipes/invitation-status-enum.pipe";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { Page } from "@models/page";
import { SkeletonModule } from "primeng/skeleton";

@Component({
    selector: "app-guests-table",
    imports: [
    TableModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    InvitationStatusEnumPipe,
    PaginatorModule,
    SkeletonModule
],
    templateUrl: "./guests-table.component.html",
    styleUrl: "./guests-table.component.scss"
})
export class GuestsTableComponent {
  first = 0;
  rows = 10;

  @Input({ required: true }) data: Page<Invitation> | null = null;
  @Input() readOnly = false;

  @Output() editGuestClick = new EventEmitter<Invitation>();
  @Output() cancelGuestClick = new EventEmitter<Invitation>();
  @Output() resendInviteClick = new EventEmitter<Invitation>();
  @Output() pageChange = new EventEmitter<PaginatorState>();

  invtationStatusEnum = InvitationStatusEnum;
}
